import {Iframe} from "../../../../../_kiloit/layout/components/iframe/Iframe";
import {useParams} from "react-router-dom";

const AppReportPage = () => {
    const {id} = useParams();
    return <Iframe tableId={id} pathname="/app-report"/>
}

export default AppReportPage